import React, { useEffect, useState } from 'react';
import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown';
import { isString } from 'lodash';
import { Document } from '@contentful/rich-text-types';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
import { captureException } from '@sentry/react';
import { RichText } from 'domains/contentful/RichText/Text';

type Props = {
  children: string;
  className?: string;
  useDefaultMargins?: boolean;
};

/** A <Paragraph/> wrapper to work with markdown text coming from contentful */
export const MarkdownText: React.FC<Props> = ({ children, useDefaultMargins, className }) => {
  if (!isString(children)) {
    throw new Error(`Error in ${MarkdownText}. Expected children to by a string but instead of ${typeof children}`);
  }

  const [document, setDocument] = useState<Document | undefined>();

  useEffect(() => {
    richTextFromMarkdown(children)
      .then(d => setDocument(d))
      .catch(e => {
        captureException(e);
      });
  }, [children]);

  if (!document) {
    return null;
  }

  return (
    <div
      className={twMerge(
        cx({
          'mb-40': useDefaultMargins, // @TODO(juan): these are still not confirmed with kim
        }),
        className,
      )}
    >
      <RichText>{document}</RichText>
    </div>
  );
};
